var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandSignatureCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241.79463 214.46525",
    xmlSpace: "preserve",
    width: 241.79463,
    height: 214.46526,
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;}\n\t.st2{fill:#0898B8;}\n\t.st3{fill:#7FC142;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g79",
    transform: "translate(-193.1031,-639.53474)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.07339,
    y1: 746.84857,
    x2: 434.76129,
    y2: 746.84857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FC142"
    },
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#45AC72"
    },
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0898B8"
    },
    id: "stop8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 314.5,854 c -14.5,-0.1 -28.6,-2.5 -42.5,-6.5 -22,-6.2 -40.5,-17.8 -54.8,-35.6 -12.3,-15.2 -20.3,-32.4 -23,-51.9 -2.9,-20.5 -0.1,-40.2 9,-58.9 6.2,-12.8 15,-23.7 26,-32.8 12.2,-10 25.7,-17.7 40.9,-22.2 16.9,-5.1 34.3,-7.2 52,-6.4 16.5,0.8 32.4,3.9 47.7,10.3 20.3,8.5 37,21.3 49.2,39.8 7.5,11.4 12.3,23.9 14.4,37.5 1.6,10.2 2,20.5 0.8,30.9 -1.7,14.4 -6.5,27.9 -14.2,40.1 -15.6,24.8 -37.8,41.1 -65.8,49.7 -9.3,2.9 -18.8,4.6 -28.4,5.3 -3.9,0.4 -7.6,0.5 -11.3,0.7 z M 275,755.7 c -1,-4.7 -1.2,-12 -0.2,-18.8 1.8,-13.3 7.4,-24.8 16.6,-34.5 10.4,-11.1 23.3,-17.6 38.4,-19.5 12.5,-1.5 24.5,0.4 35.7,6.4 13.7,7.4 23.2,18.6 29.3,32.7 7.4,17.1 8,34.8 4.6,52.8 -2.7,13.8 -8.7,26.1 -17.4,37.2 -0.6,0.7 -1.2,1.5 -1.7,2.2 0.4,0 0.8,-0.2 1,-0.4 6.6,-5.2 12.5,-11.2 17.2,-18.3 13.5,-20.2 18,-42.3 13,-66 -4.2,-20.3 -14.8,-36.7 -31.3,-49.3 -12.2,-9.3 -26,-14.7 -41.3,-16.5 -9.8,-1.1 -19.6,-0.7 -29.3,1.4 -12.6,2.7 -23.6,8.3 -33.5,16.5 -8,6.6 -14.7,14.3 -19.5,23.6 -7.7,14.8 -9.3,30.4 -6.5,46.6 2,11.1 7,20.8 15.3,28.6 12.7,11.7 30.5,13 44.7,5.5 11.7,-6.1 18.9,-16 22,-28.8 1.4,-6 4.9,-10.5 10.3,-13.5 3.6,-2 7.6,-2.7 11.7,-2.4 0.5,4.9 0.5,9.7 -0.2,14.5 -1.8,13.5 -7.4,25.3 -16.8,35.2 -11.2,11.7 -25,18.2 -41.2,19.5 -11.5,0.9 -22.5,-1.2 -32.7,-6.6 -14.5,-7.8 -24.3,-19.8 -30.4,-34.9 -6,-14.9 -6.7,-30.3 -4.3,-45.9 2.5,-16.2 9.3,-30.4 19.9,-42.9 1,-1.1 1.9,-2.3 2.9,-3.4 -0.5,0 -0.8,0.2 -1.2,0.5 -10.1,7.4 -18.2,16.6 -24.1,27.5 -9.4,17.3 -12.7,35.8 -9.6,55.3 2.5,15.9 8.8,30.2 19.6,42.1 23.3,25.7 52.2,33.8 85.7,26.3 13.3,-3 24.6,-10 34.5,-19.2 8.9,-8.2 15.7,-17.9 19.7,-29.4 3.7,-10.7 4.6,-21.7 3.4,-33 -1.3,-12 -5.6,-22.8 -13.9,-31.7 -11.4,-12.3 -27.3,-15.4 -41.9,-10 -15.6,5.8 -24.6,17.6 -27.5,33.9 -1.7,10 -10.9,17.6 -21,16.7 z",
    id: "path11",
    style: {
      fill: "url(#SVGID_1_)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSignatureCircle);
export default __webpack_public_path__ + "static/media/brandSignature_circle.f088b53518273ccc87985e6123437ad7.svg";
export { ForwardRef as ReactComponent };